'use client';

import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import { useAccordion } from '../../hooks/useAccordion';
import ChevronIcon from './chevron.icon.svg';
import './AccordionItem.scss';
export type AccordionItemProps = PropsWithChildren & {
  title: string;
  id?: string;
  className?: string;
  actionSlot?: ReactNode;
  defaultOpen?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  dataTestId?: string;
};
export const AccordionItem = t0 => {
  const $ = _c(32);
  const {
    title,
    id,
    children,
    actionSlot,
    className,
    defaultOpen,
    onOpen,
    onClose,
    dataTestId
  } = t0;
  let t1;
  if ($[0] !== defaultOpen || $[1] !== onClose || $[2] !== onOpen) {
    t1 = {
      defaultOpen,
      onOpen,
      onClose
    };
    $[0] = defaultOpen;
    $[1] = onClose;
    $[2] = onOpen;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    detailsRef,
    contentRef,
    handleClick
  } = useAccordion(t1);
  let t2;
  if ($[4] !== className) {
    t2 = cn("disclosure__item", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = Boolean(actionSlot);
  let t4;
  if ($[6] !== t3) {
    t4 = cn("disclosure__summary", {
      "disclosure__summary--with-action": t3
    });
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `${dataTestId}-header`;
  let t6;
  if ($[8] !== t5 || $[9] !== title) {
    t6 = <span className="disclosure__title" data-testid={t5}>{title}</span>;
    $[8] = t5;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="disclosure__icon" aria-hidden="true"><ChevronIcon /></span>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleClick || $[13] !== t4 || $[14] !== t6) {
    t8 = <summary className={t4} onClick={handleClick}>{t6}{t7}</summary>;
    $[12] = handleClick;
    $[13] = t4;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== children) {
    t9 = <div className="disclosure__content-inner">{children}</div>;
    $[16] = children;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== contentRef || $[19] !== t9) {
    t10 = <div className="disclosure__content" ref={contentRef}>{t9}</div>;
    $[18] = contentRef;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== detailsRef || $[22] !== t10 || $[23] !== t8) {
    t11 = <details className="disclosure__details" ref={detailsRef}>{t8}{t10}</details>;
    $[21] = detailsRef;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== actionSlot) {
    t12 = actionSlot && <div className="disclosure__action-slot">{actionSlot}</div>;
    $[25] = actionSlot;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== id || $[28] !== t11 || $[29] !== t12 || $[30] !== t2) {
    t13 = <div id={id} data-testid={id} className={t2}>{t11}{t12}</div>;
    $[27] = id;
    $[28] = t11;
    $[29] = t12;
    $[30] = t2;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};